<br /><div class="container-fluid" style="background-color:#0baddf;  ">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb crumb">

            <li class="breadcrumb-item"><a routerLink="/" style="cursor:pointer">Home</a></li>
            <li class="breadcrumb-item"><a routerLink="/Products" style="width: 82px;cursor:pointer;color:white">Products </a></li>
            <li class="breadcrumb-item"><a style="width: 82px;cursor:pointer;color:white">Products Equiry</a></li>

            

            <li class="il">
                <a href="tel:09676308014">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                         width="40" height="40"
                         viewBox="0 0 172 172"
                         style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g><path d="M72.5625,71.21875c0,8.33125 0,47.03125 0,47.03125h47.03125c25.93437,0 47.03125,-21.09687 47.03125,-47.03125c0,-25.93437 -21.09688,-47.03125 -47.03125,-47.03125c-25.93438,0 -47.03125,21.09688 -47.03125,47.03125z" fill="#ffffff"></path><path d="M10.48125,40.71563v0c-5.9125,29.5625 -5.9125,60.06563 0,89.62813v0v0c3.35938,16.93125 18.14063,29.15938 35.475,29.15938v0v0v0v0c4.43437,0 7.79375,-3.89688 7.25625,-8.33125l-3.225,-24.05313c-0.94063,-6.58438 -6.58438,-11.55625 -13.16875,-11.55625v0c-6.71875,0 -11.69062,1.74688 -11.69062,1.74688v-31.7125v-31.7125c0,0 5.10625,1.74688 11.69063,1.74688v0c6.71875,0 12.3625,-4.97188 13.16875,-11.55625l3.225,-24.05312c0.5375,-4.43438 -2.82187,-8.33125 -7.25625,-8.33125v0c-17.33437,0 -32.11562,12.09375 -35.475,29.025z" fill="#ffffff"></path><path d="M36.81875,59.52813c8.6,0 15.99062,-6.45 17.2,-15.05l3.225,-24.05312c0.40313,-3.225 -0.5375,-6.45 -2.6875,-9.00312c-2.15,-2.55312 -5.24062,-3.89687 -8.6,-3.89687c-19.21563,0.13438 -35.74375,13.70625 -39.50625,32.51875c-6.04687,30.23438 -6.04687,60.87187 0,91.10625c3.7625,18.8125 20.29062,32.38437 39.37187,32.38437c2.28438,0 4.03125,-1.74687 4.03125,-4.03125c0,-2.28438 -1.74687,-4.03125 -4.03125,-4.03125c-15.31875,0 -28.4875,-10.88437 -31.44375,-25.93437c-5.77813,-29.15938 -5.77813,-58.85625 0,-88.01562c2.95625,-15.05 16.25938,-25.93437 31.44375,-25.93437c1.34375,0 2.15,0.67188 2.41875,1.075c0.40312,0.40313 0.94062,1.34375 0.80625,2.55313l-3.225,24.05312c-0.67187,4.56875 -4.56875,8.0625 -9.27187,8.0625c-5.9125,0 -10.48125,-1.47812 -10.48125,-1.47812c-1.20937,-0.40312 -2.55312,-0.13438 -3.62812,0.5375c-1.075,0.80625 -1.6125,2.01563 -1.6125,3.225v66.1125c0,1.6125 0.94063,2.95625 2.28438,3.62813c1.34375,0.67188 3.09062,0.40312 4.3,-0.5375c0,0 4.3,-3.49375 9.1375,-3.49375c4.70313,0 8.6,3.49375 9.27187,8.0625l1.74688,12.63125c0.26875,2.01563 2.01563,3.49375 4.03125,3.49375c0.13437,0 0.40312,0 0.5375,0c2.15,-0.26875 3.7625,-2.28437 3.49375,-4.56875l-1.74688,-12.63125c-1.075,-8.33125 -8.46563,-14.78125 -17.06562,-14.78125c-2.82188,0 -5.50938,0.67188 -7.65938,1.47812v-54.01875c2.01563,0.26875 4.70312,0.5375 7.65938,0.5375z" fill="#444b54"></path><path d="M119.59375,122.28125h-47.03125c-2.28437,0 -4.03125,-1.74688 -4.03125,-4.03125v-47.03125c0,-28.21875 22.84375,-51.0625 51.0625,-51.0625c28.21875,0 51.0625,22.84375 51.0625,51.0625c0,28.21875 -22.84375,51.0625 -51.0625,51.0625zM76.59375,114.21875h43c23.65,0 43,-19.35 43,-43c0,-23.65 -19.35,-43 -43,-43c-23.65,0 -43,19.35 -43,43z" fill="#71c2ff"></path><path d="M133.03125,91.375h-33.59375c-2.28437,0 -4.03125,-1.74688 -4.03125,-4.03125c0,-2.28437 1.74688,-4.03125 4.03125,-4.03125h33.59375c2.28438,0 4.03125,1.74688 4.03125,4.03125c0,2.28437 -1.74687,4.03125 -4.03125,4.03125z" fill="#71c2ff"></path><path d="M133.03125,71.21875h-33.59375c-2.28437,0 -4.03125,-1.74688 -4.03125,-4.03125c0,-2.28437 1.74688,-4.03125 4.03125,-4.03125h33.59375c2.28438,0 4.03125,1.74688 4.03125,4.03125c0,2.28437 -1.74687,4.03125 -4.03125,4.03125z" fill="#71c2ff"></path><path d="M63.69375,163.53438c-2.28438,0 -4.03125,-1.74688 -4.03125,-4.03125c0,-2.28438 1.74687,-4.03125 4.03125,-4.03125c5.10625,0 9.80937,-2.01562 13.4375,-5.50938c0.80625,-0.80625 1.88125,-1.20937 2.95625,-1.20937c1.075,0 2.15,0.5375 2.95625,1.34375c2.41875,2.6875 5.77813,4.3 9.40625,4.3c3.62812,0.13438 6.9875,-1.20937 9.675,-3.89687l0.67188,-0.67187c1.6125,-1.6125 4.16562,-1.6125 5.64375,0l1.34375,1.34375c2.41875,2.41875 5.77812,3.89687 9.27188,3.89687c3.49375,0 6.85312,-1.34375 9.27187,-3.89687l1.34375,-1.34375c1.6125,-1.6125 4.16563,-1.6125 5.64375,0l6.71875,6.71875c1.6125,1.6125 1.6125,4.16563 0,5.64375c-1.6125,1.6125 -4.16562,1.6125 -5.64375,0l-3.89687,-3.89688c-3.7625,3.09063 -8.46563,4.70313 -13.30313,4.70313c-4.97188,0 -9.675,-1.74687 -13.57187,-4.8375c-3.7625,2.82187 -8.33125,4.3 -13.30313,4.16562c-4.56875,-0.13437 -8.73437,-1.6125 -12.22813,-4.3c-4.97188,3.62812 -10.48125,5.50938 -16.39375,5.50938z" fill="#444b54"></path></g></g></svg>
                </a>
            </li>
            

        </ol>
    </nav>
</div>
<div class="container bred_border">
    <div class="row page_mar_t">

     
    </div>

</div>



<div class="container">

  

    <div class="row" style="margin-top:6px;">

        <div class="col-lg-8">
            <div class="prodd">PRODUCT DETAILS</div>

            <div class="col-lg-12 contact-form" *ngFor="let item of cartlist">
                <div class="container">
                    <h4 class="mainHeader" style="color:#0211a0;font-size: 20px;">{{item.ChemicalName}}</h4>
                    <img src="../../../assets/delete.png"(click)="deleteFromCart(i)" class="delete" style="cursor:pointer"/>
                    
                    <div class="row ">
                        <div class="col-lg-7">




                            <h3 class="aboutFont" *ngIf="item.Catalog_No!=''">Catlog No</h3>
                            <a href="product-details.component.html"></a>
                            <div class=" casn" *ngIf="item.Catalog_No!=''">
                                {{item.Catalog_No}}
                            </div>

                            <h3 class="aboutFont" *ngIf="item.Cas!=''">CAS</h3>
                            <a href="product-details.component.html"></a>
                            <div class=" casn" *ngIf="item.Cas!=''">
                                {{item.Cas}}
                            </div>
                            <h3 class="aboutFont" *ngIf="item.Formula!=''">formula </h3>
                            <a href="product-details.component.html"></a>
                            <div class="casn" *ngIf="item.Formula!=''">
                                {{item.Formula}}
                            </div>

                            <h3 class="aboutFont" *ngIf="item.BoilingPoint!=''">Boiling Point </h3>
                            <a href="product-details.component.html"></a>
                            <div class="casn" *ngIf="item.BoilingPoint!=''">
                                {{item.BoilingPoint}}
                            </div>
                            <h3 class="aboutFont" *ngIf="item.MolecularWeight!=''">Molecular Weight </h3>
                            <a href="product-details.component.html"></a>

                            <div class="aboutFont" *ngIf="item.MolecularWeight!=''">
                                {{item.MolecularWeight}}
                            </div>

                           

                            <h3 class="aboutFont" *ngIf="item.MeltingPoint!=''">MeltingPoint </h3>
                            <a href="product-details.component.html"></a>
                            <div class="casn" *ngIf="item.MeltingPoint!=''">
                                {{item.MeltingPoint}}
                            </div>

                            <h3 class="aboutFont" *ngIf="item.PhysicalState!=''">Physical State </h3>
                            <a href="product-details.component.html"></a>
                            <div class="casn" *ngIf="item.PhysicalState!=''">
                                {{item.PhysicalState}}
                            </div>

                            <h3 class="aboutFont" *ngIf="item.Storage!=''">Storage </h3>
                            <a href="product-details.component.html"></a>
                            <div class="casn" *ngIf="item.Storage!=''">
                                {{item.Storage}}
                            </div>



                            <h3 class="aboutFont" *ngIf="item.Apiname!=''">Apiname </h3>
                            <a href="product-details.component.html"></a>
                            <div class="casn" *ngIf="item.Apiname!=''">
                                {{item.Apiname}}
                            </div>


                            <h3 class="aboutFont" *ngIf="item.Synonym!=''">Synonym </h3>
                            <a href="product-details.component.html"></a>
                            <div class="casn" *ngif="item.Synonym!=''">
                                {{item.Synonym}}
                            </div>

                        </div>

                        <div class="col-lg-5">
                            <div *ngIf="item.Structure != null ||item.Structure != '' ">
                                <a href="{{HomeUrl+item.Structure}}" target="-blank"> <img src="{{HomeUrl+item.Structure}}" alt="REAX" *ngIf="item.Structure"></a>

                            </div>
                            <div *ngIf=" item.Structure == null || item.Structure == '' ">

                                <a href="../../../assets/Reaxlogo_1.png" target="-blank" style="height:200%"><img src="../../../assets/Reaxlogo_1.png" target="-blank" style="width:90%;" /></a>


                            </div>
                        </div>

                    </div>




                </div>
            </div>

        </div>
    
        <div class="col-lg-4">
            <div class=" mobileView top">
                <div class="scrollCard">
                    <div class="prodd2" >PRODUCT ENQUIRY</div>
                </div>


                <div class="row">
                    <div class="container">

                        <div class="contact-form">


                            <form #contactForm="ngForm" (ngSubmit)="onSubmit(contactForm.value)">
                                <div class="row">

                                    <div class="form-group mb-3">
                                        <label>Name</label>
                                        <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel" class="form-control" id="name">
                                        <div class="alert alert-danger" *ngIf="name.touched && !name.valid">
                                            <div *ngIf="name.errors.required">Name is required.</div>
                                            <div *ngIf="name.errors.minlength">Name is minimum {{ name.errors.minlength.requiredLength }} character.</div>
                                            <div *ngIf="name.errors.maxlength">Name is maximum 50 character.</div>
                                        </div>

                                    </div>

                                    <div class="form-group mb-3">
                                        <label>Email</label>
                                        <input required ngModel name="email" type="text" #email="ngModel" class="form-control" id="email">
                                        <div class="alert alert-danger" *ngIf="email.touched && !email.valid">Email Address is required.</div>

                                    </div>


                                    <div class="form-group mb-3">
                                        <label>Phone Number</label>
                                        <input required ngModel name="number" type="text" #number="ngModel" class="form-control" id="number">
                                        <div class="alert alert-danger" *ngIf="number.touched && !number.valid">Phone number is required.</div>

                                    </div>
                                    <div class="col-lg-12 col-md-12">
                                        <div class="form-group mb-3">
                                            <label>Message</label>
                                            <textarea required ngModel #message="ngModel" name="message" id="message" cols="30" rows="4" class="form-control"></textarea>
                                            <div class="alert alert-danger" *ngIf="message.touched && !name.valid">Message is required.</div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12">
                                        <button type="submit" class="btn22 " [class.disabled]="!contactForm.valid">Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>

                <br />



            </div>





        </div>
    </div>
    </div>


<style>




    tr.break td {
        height: 10px;
    }
</style>
